import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

import categoriesScaffolding from './categoriesScaffolding/reducer';
import auth from './auth/reducer';
import ui from './ui/reducer';
import drivers from './drivers/reducer';
import companies from './companies/reducer';
import staff from './staff/reducer';

const root = combineReducers({
    categoriesScaffolding,
    companies,
    drivers,
    staff,
    auth,
    ui,
    toastr: toastrReducer
});

export default root;



// WEBPACK FOOTER //
// ./src/ducks/index.js